<h1>"{{searchString}}" is ...</h1>
<div>
  <app-info-entry-container *ngFor="let entry of resultEntries" [infoEntry]="entry"></app-info-entry-container>
</div>
<div *ngIf="disposable == null && resultEntries.length==0">Probably is someone 9 type some text C:</div>
